import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  button {
    img {
      margin-right: 8px;
    }

    + button {
      margin-top: 8px;
    }
  }
`;
